import { useParams, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { apiFetch } from "../api/api";

export default function IbuDetail() {
  const { id } = useParams();
  const [data, setData] = useState<any>(null);

  useEffect(() => {
    apiFetch(`/admin/user/${id}/summary`).then(res => setData(res.data));
  }, [id]);

  if (!data) {
    return (
      <div className="p-6 text-gray-500 animate-pulse">
        Memuat data ibu...
      </div>
    );
  }

  const { profile, weekly, gula_darah } = data;

  return (
    <div className="space-y-6">
      {/* HEADER */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <h1 className="text-3xl font-bold text-purple-700">
            {profile.nama}
          </h1>
          <p className="text-sm text-gray-500">
            Detail data ibu hamil
          </p>
        </div>

        <Link
          to="/ibu"
          className="px-4 py-2 rounded-lg border border-purple-300 text-purple-700 hover:bg-purple-50"
        >
          ← Kembali
        </Link>
      </div>

      {/* MAIN GRID */}
      <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
        {/* ================= PROFIL ================= */}
        <Card title="Profil Ibu">
          <Item label="Usia" value={`${profile.usia} tahun`} />
          <Item label="Usia Kehamilan Awal" value={`${profile.usia_kehamilan_awal} minggu`} />
          <Item label="Berat Badan Awal" value={`${profile.berat_badan_awal} kg`} />
          <Item label="Tinggi Badan" value={`${profile.tinggi_badan} cm`} />
          <Item label="Aktivitas Fisik" value={profile.aktivitas_fisik} />
          <Item label="Riwayat DM" value={profile.riwayat_dm ? "Ya" : "Tidak"} />
          <Item label="Riwayat Bayi Besar" value={profile.riwayat_bayi_besar ? "Ya" : "Tidak"} />
          <Item label="Alamat" value={profile.alamat} />
        </Card>

        {/* ================= LAPORAN MINGGUAN ================= */}
        <Card title="Laporan Mingguan">
          {weekly?.id ? (
            <>
              <Item label="Minggu Ke" value={weekly.minggu_ke} />
              <Item label="Periode" value={`${weekly.start_date} – ${weekly.end_date}`} />
              <Item label="Persentase Kepatuhan">
                <span className="font-bold text-lg">
                  {weekly.persentase}%
                </span>
              </Item>
              <Item label="Status">
                <StatusBadge status={weekly.status} />
              </Item>
            </>
          ) : (
            <EmptyState text="Belum ada laporan mingguan" />
          )}
        </Card>

        {/* ================= GULA DARAH ================= */}
        <Card title="Gula Darah Terakhir">
          {gula_darah?.id ? (
            <>
              <Item label="Tanggal" value={gula_darah.tanggal} />
              <Item label="GDP" value={`${gula_darah.gdp} mg/dL`} />
              <Item label="GD 2 Jam" value={`${gula_darah.gd2j} mg/dL`} />
              <Item label="OGTT" value={`${gula_darah.ogtt} mg/dL`} />
              <Item label="Kategori">
                <RiskBadge risk={gula_darah.kategori} />
              </Item>
            </>
          ) : (
            <EmptyState text="Belum ada data gula darah" />
          )}
        </Card>
      </div>
    </div>
  );
}

/* =========================
   UI COMPONENTS
========================= */

function Card({ title, children }: any) {
  return (
    <div className="bg-white rounded-2xl shadow p-6">
      <h3 className="font-semibold text-purple-700 mb-4 text-lg">
        {title}
      </h3>
      <div className="space-y-3 text-sm">{children}</div>
    </div>
  );
}

function Item({ label, value, children }: any) {
  return (
    <div className="flex justify-between gap-4">
      <span className="text-gray-500">{label}</span>
      <span className="font-medium text-gray-700 text-right">
        {children ?? value ?? "-"}
      </span>
    </div>
  );
}

function StatusBadge({ status }: { status: string }) {
  const color =
    status === "Baik"
      ? "bg-green-100 text-green-700"
      : status === "Cukup"
      ? "bg-yellow-100 text-yellow-700"
      : "bg-red-100 text-red-700";

  return (
    <span className={`px-3 py-1 rounded-full font-semibold ${color}`}>
      {status}
    </span>
  );
}

function RiskBadge({ risk }: { risk: string }) {
  const color =
    risk === "Normal"
      ? "bg-green-100 text-green-700"
      : risk === "Waspada"
      ? "bg-yellow-100 text-yellow-700"
      : "bg-red-100 text-red-700";

  return (
    <span className={`px-3 py-1 rounded-full font-semibold ${color}`}>
      {risk}
    </span>
  );
}

function EmptyState({ text }: { text: string }) {
  return (
    <div className="text-gray-400 italic text-center py-6">
      {text}
    </div>
  );
}
